/**
 * Component Registry for 206 Bell Apartments
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-aster and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-aster/registry';
import { QualifyingCriteria } from './components/QualifyingCriteria';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Example: Override the Footer with a custom component
  // Footer: Footer,
  QualifyingCriteria,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
